import Spinner from "common/component/Spinner";
import { menuArray } from "common/container/constants";
import { Header } from "common/container/Layout/header";
import { LeftSidebar } from "common/container/Layout/sidebar/left";
import RightSidebar from "common/container/Layout/sidebar/right";
import { ProfilePage } from "pages/profilePage";
import { useEffect, useState } from "react";
import { scroller } from "react-scroll";
import { Parallax, ParallaxProvider } from "react-scroll-parallax";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import "tailwindcss/tailwind.css";
import "./styles/global.css";
// App Component
const App = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [color, setColor] = useState("");
  const [activeSection, setActiveSection] = useState("home");
  const [loading, setLoading] = useState(true);

  const scrollToSection = (id) => {
    scroller.scrollTo(id, {
      duration: 200,
      delay: -10,
      smooth: "easeInOutQuart",
    });
  };

  const handleScroll = () => {
    const sections = menuArray.map((section) => document.getElementById(section.speed));
    const viewportHeight = window.innerHeight;

    for (let i = 0; i < sections.length; i++) {
      const element = sections[i];

      if (element) {
        const rect = element.getBoundingClientRect();

        if (rect.top >= viewportHeight * 0.25 && rect.top < viewportHeight * 0.75) {
          setActiveSection(menuArray[i].speed);
          setColor(menuArray[i].speed);
          break;
        }
      }
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [menuArray]);

  return loading ? (
    <Spinner />
  ) : (
    <ParallaxProvider>
      <div className="flex flex-col">
        <section id="home" className="min-h-screen">
          <Parallax speed={5}>
            <ProfilePage scrollToSection={scrollToSection} />
          </Parallax>
        </section>

        <div className="font-openSans text-[17px] flex flex-col sm:flex-row relative">
          {/* Left Sidebar */}
          <div
            className={`hidden md:sticky md:block bg-primary-color transition-transform transform ${
              isSidebarOpen ? "translate-x-0" : "-translate-x-full"
            } sm:translate-x-0 w-[20%] min-h-screen z-40 flex-shrink-0`}
          >
            <LeftSidebar
              color={color}
              setColor={setColor}
              setSideBarOpen={setIsSidebarOpen}
              isSidebarOpen={isSidebarOpen}
              onItemClick={scrollToSection}
            />
          </div>

          {/* Main Content */}
          <div className="flex-1 text-[14px] md:text-[16px]  relative">
            {menuArray.map((item, index) => (
              <section id={item.speed} className={`min-h-[1000px]  `}>
                <Parallax speed={-3} style={{ opacity: 4 }}>
                  <Header title={item.name} />
                  <item.component />
                </Parallax>
              </section>
            ))}
          </div>
        </div>

        {/* Right Sidebar */}
        <div className=" block  md:hidden fixed top-0 right-0 w-[10%] xl:w-[3%] md:w-[5%] min-h-screen z-50">
          <RightSidebar color={color} setColor={setColor} />
        </div>
      </div>
      <ToastContainer autoClose={1000} />
    </ParallaxProvider>
  );
};

export default App;
